/*
 * b-form-datepicker'ın yerleşik etiketleri bootstrap-vue'da İngilizce gelir;
 * dil ve etiketler buradan verilir: <b-form-datepicker v-bind="datepickerProps" />
 */
const LABELS = [
  'labelPrevDecade',
  'labelPrevYear',
  'labelPrevMonth',
  'labelCurrentMonth',
  'labelNextMonth',
  'labelNextYear',
  'labelNextDecade',
  'labelToday',
  'labelSelected',
  'labelNoDateSelected',
  'labelCalendar',
  'labelNav',
  'labelHelp',
]

export const datepickerLocale = {
  computed: {
    datepickerProps() {
      const props = { locale: this.$i18n.locale }
      LABELS.forEach(label => {
        props[label] = this.$t(`datepicker.${label}`)
      })
      return props
    },
  },
}

export default datepickerLocale
